import React, { FC, useState } from 'react'
import styled from 'styled-components'

import { Icon } from '@wirtualna-polska/n2cr-ds'
import Expandable from '@ads/front-core/components/Expandable'
import { Text } from '../CssStyled'

interface IExpansionPanel {
  label: string
}

const ExpansionPanel: FC<IExpansionPanel> = ({ label, children }) => {
  const [isExpansionPanelOpen, setIsExpansionPanelOpen] = useState(false)

  const handleToggleIsOpen = () => {
    setIsExpansionPanelOpen(state => !state)
  }

  return (
    <Container onClick={handleToggleIsOpen}>
      <TitleWrapper>
        <Text bold>{label}</Text>
        <Icon
          name={isExpansionPanelOpen ? '20-chevron-up' : '20-chevron-down'}
        />
      </TitleWrapper>
      <ExpandableStyled isExpanded={isExpansionPanelOpen}>
        <ContentWrapper>
          <Text>{children}</Text>
        </ContentWrapper>
      </ExpandableStyled>
    </Container>
  )
}

const Container = styled.div`
  padding: 16px 32px;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
`

const TitleWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

const ContentWrapper = styled.div`
  padding: 32px 0 16px;
`

const ExpandableStyled = styled(Expandable)`
  padding: 0;
  margin: 0;
`

export default ExpansionPanel
